import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { Grid, Paper, Card, CardContent, CardMedia, Typography, Skeleton, IconButton, Button} from '@mui/material'
import SEO from './seo/seo'
import LayoutWrapper from './reusable/LayoutWrapper';
import FacebookIcon from '@mui/icons-material/Facebook';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import XIcon from '@mui/icons-material/X';
import EmailIcon from '@mui/icons-material/Email';
import PinterestIcon from '@mui/icons-material/Pinterest';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { createClient } from '@sanity/client'
import { useEffect, useState } from 'react';
import imageUrlBuilder from '@sanity/image-url'



export const client = createClient({
    projectId: 'bycy8yw9',
    dataset: 'production',
    useCdn: true, // set to `false` to bypass the edge cache
    apiVersion: '2022-03-07', // use current date (YYYY-MM-DD) to target the latest API version
    // token: process.env.SANITY_SECRET_TOKEN // Only if you want to update content with the client
})

const builder = imageUrlBuilder(client)

function urlFor(source) {
    return builder.image(source)
}

export async function getPosts(slug) {
    const posts = await client.fetch('*[_type == "post"&&slug.current == $slug]', { slug })
    return posts
}


function shareOnFacebook() {
    window.open('https://www.facebook.com/sharer/sharer.php?u=' + window.location.href, '_blank')
}

function shareOnWhatsApp() {
    window.open('https://wa.me/?text=' + window.location.href, '_blank')
}

function shareOnPinterest() {
    window.open('https://pinterest.com/pin/create/button/?url=' + window.location.href, '_blank')
}

function shareOnX() {
    window.open('https://twitter.com/intent/tweet?url=' + window.location.href, '_blank');
}

function shareByEmail() {
    window.open('mailto:?subject=Schau dir diesen Artikel an!&body=Ich habe diesen interessanten Artikel gefunden und wollte ihn mit dir teilen: ' + window.location.href, '_blank')
}







export default function ArticlePage(props) {
    const navigate = useNavigate();
    const location = useLocation();
    const [post, setPost] = useState(null);


    useEffect(() => {
        getPosts(decodeURI(location.pathname.split('/')[2])).then(result => {
            setPost(result);
        });
    }, [location]);

    if (post && post.length === 0) {
        alert('Artikel wurde nicht gefunden');
        window.location.href = '/Artikel#not_found';
        return null;
    }

    return (
        <>
            {post ? <SEO
                title={post[0].title + ' - PocketPet'}
                description={post[0].description}
                type='article' 
                image={urlFor(post[0].mainImage).height(200).width(500).format('webp').url()}
                /> : null
            }

            <LayoutWrapper small={true}>
                {post ? <HeaderCard post={post} /> : <SkeletonHeaderCard />}
                {post ? <BlogPost post={post} /> : null}
                <Button startIcon={<ArrowBackIosIcon />} onClick={() => {navigate('/Artikel')}} color='primary' fullWidth={true} size='large' variant='contained' sx={{ height: '60px' }}>
                    Alle Artikel
                </Button>
            </LayoutWrapper>

        </>

    )
}



function HeaderCard(props) {
    const post = props.post[0];

    return (
        <Card elevation={3} sx={{ marginBottom: 2 }}>
            {post.mainImage && (
                <CardMedia
                    component="img"
                    src={urlFor(post.mainImage).height(200).width(500).format('webp').url()}
                    alt={post.mainImage.alt || "Blog über Hunde"}
                    title={post.mainImage.title || "Blog über Hunde"}
                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                />
            )}
            <CardContent sx={{ paddingX: 3 }}>
                <Typography variant="h3" variantMapping={{h3: "h1"}} mb={2} align="center">
                    {post.title}
                </Typography>
                <Typography variant="body1">
                    {post.description}
                </Typography>

            </CardContent>

            <CardContent sx={{ paddingX: 3 }}>
                <Grid container justifyContent="space-around" alignItems="center">
                    <IconButton onClick={() => shareOnFacebook()} aria-label="Share on Facebook">
                        <FacebookIcon />
                    </IconButton>
                    <IconButton onClick={() => shareOnWhatsApp()} aria-label="Share on WhatsApp">
                        <WhatsAppIcon />
                    </IconButton>
                    <IconButton onClick={() => shareOnPinterest()} aria-label="Share on Pinterest">
                        <PinterestIcon />
                    </IconButton>
                    <IconButton onClick={() => shareOnX()} aria-label="Share on X">
                        <XIcon />
                    </IconButton>
                    <IconButton onClick={() => shareByEmail()} aria-label="Share by Email">
                        <EmailIcon />
                    </IconButton>

                </Grid>
            </CardContent>


        </Card>
    );
}


function SkeletonHeaderCard(props) {
    return (
        <Card elevation={3} sx={{ marginBottom: 2 }}>
            <Skeleton variant="rectangular" width="100%" height={200} />
            <CardContent>
                <Typography variant="h3" mb={2} align="center">
                    <Skeleton />
                    <Skeleton />
                </Typography>
                <Typography variant="body1">
                    <Skeleton />
                    <Skeleton />
                </Typography>
            </CardContent>

            <CardContent>
                <Grid container justifyContent="space-around" alignItems="center">
                    <IconButton onClick={() => shareOnFacebook()}>
                        <FacebookIcon />
                    </IconButton>
                    <IconButton onClick={() => shareOnWhatsApp()}>
                        <WhatsAppIcon />
                    </IconButton>
                    <IconButton onClick={() => shareOnPinterest()}>
                        <PinterestIcon />
                    </IconButton>
                    <IconButton onClick={() => shareOnX()}>
                        <XIcon />
                    </IconButton>
                    <IconButton onClick={() => shareByEmail()}>
                        <EmailIcon />
                    </IconButton>

                </Grid>
            </CardContent>
        </Card>
    );
}

function BlogPost(props) {
    const body = props.post[0].body;
    return (
        <Paper elevation={3} sx={{ padding: 5 , marginBottom: 2}}>
            {body.map((block, index) => {
                switch (block._type) {
                    case 'block':
                        switch (block.style) {
                        case 'normal':
                            if (block.listItem === 'bullet') {
                                return (
                                    <ul key={index}>
                                        <li>
                                            <Typography variant="body1" mb={2}>
                                                {block.children.map((child, childIndex) => {
                                                    if (child.marks.includes('strong')) {
                                                        return (
                                                            <strong key={childIndex}>
                                                                {child.text}
                                                            </strong>
                                                        );
                                                    } else if (child.marks.includes('em')) {
                                                        return (
                                                            <em key={childIndex}>
                                                                {child.text}
                                                            </em>
                                                        );
                                                    } else {
                                                        return child.text;
                                                    }
                                                })}
                                            </Typography>
                                        </li>
                                    </ul>
                                );
                            } else {
                                return (
                                    <Typography key={index} variant="body1" mb={2}>
                                        {block.children.map((child, childIndex) => {
                                            if (child.marks.includes('strong')) {
                                                return (
                                                    <strong key={childIndex}>
                                                        {child.text}
                                                    </strong>
                                                );
                                            } else if (child.marks.includes('em')) {
                                                return (
                                                    <em key={childIndex}>
                                                        {child.text}
                                                    </em>
                                                );
                                            } else {
                                                return child.text;
                                            }
                                        })}
                                    </Typography>
                                );
                            }
                            case 'h1':
                                return <Typography key={index} variant="h4" variantMapping={{ h4: 'h2' }} mb={2}>{block.children[0].text}</Typography>;
                            case 'h2':
                                return <Typography key={index} variant="h5" variantMapping={{ h5: 'h3' }} mb={2}>{block.children[0].text}</Typography>;
                            case 'h3':
                                return <Typography key={index} variant="h5" variantMapping={{ h5: 'h4' }} mb={2}>{block.children[0].text}</Typography>;
                            case 'h4':
                                return <Typography key={index} variant="h5" >{block.children[0].text} mb={2}</Typography>;
                            case 'blockquote':
                                return <Typography key={index} variant="body1" sx={{ fontStyle: 'italic' }}>{block.children[0].text}</Typography>;
                            
                            default:
                                return 'olummmmmm';
                        }
                    case 'image':
                        return (
                            <img
                                key={index}
                                src={urlFor(block).height(300).width(500).format('webp').url()}
                                alt={block.alt || "Blog über Hunde"}
                                title={block.title || "Blog über Hunde"}
                                style={{ width: '100%', height: '100%', objectFit: 'cover'}}
                            />
                        );
                    default:
                        return null;
                }
            })}
        </Paper>
    );

}
